import React from 'react'

const Otheraboutusblmprofile = () => {
  return (
    <div className='uploadbannerblmdiv'>
                <div className='uploadbannerdivnewmain'>
                    <div className="consttactdetatlsarroedyrdiv">
                        <p className="cinnattddttdtsttspo">About Us</p>
                       
                    </div>
                    <div className='abttsrtxtdivvnappadin'>
                        <p className='abttsbttetxtttpp'>
                            Neoo Search is a business network and online directory platform for small and medium-sized businesses. This platform is a one-stop marketing solution to identify and do business with SME's and verified companies, drive more connections, and build new networks and leads. Neoo search business netwrok lets you discover and access a whole new world of business opportunities from across the world. Having a business of our own, we know the value of being able to share tips and information, develop relationships with other businesses, and have somewhere to look for information.
                        </p>
                        <p className='abttsbttetxtttpp'>
                            We have provided a wealth of information to help you market your business by letting you search for and access your target customers. The platform allows you to create unlimited opportunities that are visible to thousands of other companies in the world. You can also search for and contact other entrepreneurs in a safe and reliable environment. Besides, you can also use search tools to generate more leads with Neoo Search.
                        </p>
                    </div>
                </div>
            </div>
  )
}

export default Otheraboutusblmprofile
